import React from "react";
import { DreamhubGradient } from "@dreamhub/designsystem/icons";
import IconContainer, { iconSize } from "@/components/ui/icon-container";
import { cn } from "@/utils/utils";
import { getOverlapMargin, OVERLAP_SHADOW } from "./dreamerIconStyles";

const GRADIENT_BACKGROUND =
  "linear-gradient(180deg, var(--opacity-white-16, rgba(255, 255, 255, 0.16)) 0%, var(--opacity-black-24, rgba(12, 17, 29, 0.24)) 100%)";
const ICON_CONTAINER_BASE_CLASS =
  "border-[0.5px] border-border-border2 rounded-lg p-[1.5px] backdrop-blur-lg";

const getIconSize = (size: iconSize) =>
  size === "sm" ? "size-[20px]" : "size-[22px]";

interface DreamerIconProps {
  size: iconSize;
  isOverlapping?: boolean;
  isDimmed?: boolean;
  shouldUseIconContainer?: boolean;
}

export const DreamerIcon: React.FC<DreamerIconProps> = ({
  size,
  isOverlapping = false,
  isDimmed = false,
  shouldUseIconContainer = false
}) => (
  <div
    className={cn(
      ICON_CONTAINER_BASE_CLASS,
      "flex items-center justify-center",
      !shouldUseIconContainer && getIconSize(size),
      isOverlapping && getOverlapMargin(size),
      isDimmed && "opacity-65"
    )}
    style={{
      background: GRADIENT_BACKGROUND,
      ...(isOverlapping && { boxShadow: OVERLAP_SHADOW })
    }}
  >
    {shouldUseIconContainer ? (
      <IconContainer size={size}>
        <DreamhubGradient />
      </IconContainer>
    ) : (
      <DreamhubGradient />
    )}
  </div>
);
